import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

const TeamMembersContext = createContext();

const initialState = {
  showTeamMembers: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SHOW_TEAM_MEMBERS': {
      return {
        ...state,
        showTeamMembers: action.payload.showTeamMembers,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export const TeamMembersProvider = ({ children }) => {
  const [{ showTeamMembers }, dispatch] = useReducer(reducer, initialState);
  const values = useMemo(() => ({
    showTeamMembers,
    dispatch,
  }));
  return <TeamMembersContext.Provider value={values}>{children}</TeamMembersContext.Provider>;
};

TeamMembersProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TeamMembersContext;
